import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import FormikDownshift from './FormikDownshift';

import CustomerService from 'services/CustomerService';
import HintText from 'components/labels/HintText';
import ButtonStatus from 'components/buttons/ButtonStatus';
import { capatilizeFirst } from 'commons/utils/stringUtils';
import CustomerFormModal from 'views/customers/CustomerFormModal';
import { LinearProgress } from '@mui/material';

function CustomerDownshift({ getSuggestionLabel, hideAddCustomers, onAdd, ...others }) {
  const refNewDefaultName = useRef('');
  const [formModalOpen, setFormModalOpen] = useState(false);

  const handleSearchTerm = React.useCallback((inputValue) => {
    return CustomerService.search(inputValue).then((data) => {
      return data;
    });
  }, []);

  const areItemsDifferentChecker = (prevItem, item) => {
    return (
      (prevItem == null && item != null) ||
      (prevItem != null && item == null) ||
      (prevItem != null && item != null && prevItem.id !== item.id)
    );
  };

  const handleCloseForm = () => {
    setFormModalOpen(false);
  };

  const handleCreateCustomer = (newCreatedItem) => {
    setFormModalOpen(false);
    onAdd(newCreatedItem);
  };

  return (
    <>
      {formModalOpen && (
        <CustomerFormModal
          open={formModalOpen}
          defaultName={refNewDefaultName.current}
          onClose={handleCloseForm}
          onCreateCallback={handleCreateCustomer}
        />
      )}
      <FormikDownshift
        onChangeSearchTerm={handleSearchTerm}
        getSuggestionLabel={getSuggestionLabel}
        areItemsDifferentChecker={areItemsDifferentChecker}
        placeholder="Digite para buscar..."
        noOptionsNode={(mySearchTerm, mySelectedItem, myCloseMenu, myIsLoading, mySuggestionsIsNull) => {
          return (
            <div>
              <div>
                <HintText>
                  {myIsLoading ? 'Buscando...' : ''}
                  {!myIsLoading && mySearchTerm.trim().length === 0 ? 'Digite para buscar...' : ''}
                  {!myIsLoading && !mySuggestionsIsNull && mySearchTerm.trim().length > 0
                    ? 'Nenhum resultado encontrado.'
                    : ''}
                </HintText>
                {myIsLoading && <LinearProgress />}
              </div>
              {!hideAddCustomers && (
                <div style={{ marginTop: '10px' }}>
                  {!myIsLoading && (
                    <ButtonStatus
                      status="success"
                      size="small"
                      onClick={() => {
                        refNewDefaultName.current = capatilizeFirst(mySearchTerm);
                        setFormModalOpen(true);
                      }}
                      variant="contained"
                      fullWidth
                    >
                      Adicionar Cliente
                    </ButtonStatus>
                  )}
                </div>
              )}
            </div>
          );
        }}
        {...others}
      />
    </>
  );
}

CustomerDownshift.defaultProps = {
  getSuggestionLabel: (object) => {
    return object.name;
  },
  onChange: () => {},
};
CustomerDownshift.propTypes = {
  getSuggestionLabel: PropTypes.func,
  onChange: PropTypes.func,
};
export default CustomerDownshift;
